import * as Masonry from 'masonry-layout';
let _ = require('lodash');

// Remove no-js class from body when Javascript is activated
document.body.classList.remove('no-js');
document.body.classList.add('js')

// Masonry layout
const textualTeaserOverview = document.getElementsByClassName('field--name-textual-teasers');

Array.from(textualTeaserOverview).forEach(teaserOverview => {
    const masonryTextualTeasers = new Masonry(teaserOverview, {
        itemSelector: '.teaser',
    })
});

// Function: Make whole card clickable
function clickableCard() {
    let link = this.getElementsByTagName('A')[0];

    if (link.hasAttribute('type') || this.classList.contains('target-blank')) {
        window.open(link, '_blank');
    } else {
        window.open(link, '_self');
    }
}

// Make whole teaser clickable
let teasers = document.getElementsByClassName('layout-teaser');

Array.from(teasers).forEach(teaser => {
    let link = teaser.getElementsByTagName('A')[0];

    if (!_.isNil(link)) {
        teaser.addEventListener('click', clickableCard, false);
        teaser.style.cursor = 'pointer';
    }
});

// Stop video playing in header
let stopVideoButton = document.querySelector('.paragraph--type-header-video button.stop-video');
let headerVideo = document.querySelector('.paragraph--type-header-video .field--name-field-video video');

if (! _.isNil(stopVideoButton) && ! _.isNil(headerVideo)) {
    stopVideoButton.addEventListener('click', function () {
        headerVideo.pause();
    });
}

// Tabs component: Buttons act as anchor links on mobile view
const tabComponent = document.getElementsByClassName('vue-tabs-component');

if (! _.isEmpty(tabComponent)) {
    Array.from(tabComponent).forEach(component => {
        const buttons = component.querySelectorAll('.vue-tab-button button');

        if (window.innerWidth < 768) {
            Array.from(buttons).forEach(button => {
                button.addEventListener('click', (e) => {
                    const content = component.querySelector('.tab-content');

                    content.scrollIntoView();
                });
            });
        }
    });
}